import { useState, useEffect } from 'react'

const PHONE_BREAKPOINT = 600

export function useIsPhone() {
    const [isPhone, setIsPhone] = useState(() => window.innerWidth < PHONE_BREAKPOINT)

    useEffect(() => {
        const handleResize = () => setIsPhone(window.innerWidth < PHONE_BREAKPOINT)
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return isPhone
}

export function useIsTouchDevice() {
    const [isTouch] = useState(() => {
        // pointer:coarse = primary input is a finger/stylus (phones, tablets).
        // Avoids false positives on desktop browsers that report
        // ontouchstart / maxTouchPoints > 0 because of trackpad support.
        const coarse = window.matchMedia('(pointer: coarse)').matches
        const noHover = window.matchMedia('(hover: none)').matches
        return coarse && noHover
    })
    return isTouch
}
